import { CheckIssuedCardResultVm } from "./CheckIssuedCardResultVm";

export class MemberStateVm {
  MemberStateCode: string = "";
  StatusCode: number = 0;
  StatusMessage: string = "";
  CheckIssuedCardResult: CheckIssuedCardResultVm[] = [];
}
